/**
 * Builds the list used in the SchoolScore side panel year selector.
 * First entry is the "All Years" label, followed by year strings.
 */
export function getSchoolScoreYears(_pageLc, startYear = 2022, endYear = new Date().getFullYear()) {
  const allYearsLabel = "All Years";
  const safeStart = Number.isFinite(+startYear) ? +startYear : 2022;
  const safeEnd = Number.isFinite(+endYear) ? +endYear : new Date().getFullYear();

  const years = [];
  for (let y = safeStart; y <= safeEnd; y += 1) years.push(String(y));

  return [allYearsLabel, ...years];
}


